import { PortraitOutlined } from "@material-ui/icons";
import { DemoAccountsList } from "./DemoAccountsList";
import { DemoAccountCreate } from "./DemoAccountCreate";
import { DemoAccountEdit } from "./DemoAccountEdit";

export default {
  icon: PortraitOutlined,
  list: DemoAccountsList,
  create: DemoAccountCreate,
  edit: DemoAccountEdit,
};
